import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";

import styles from "../../../assets/styles/modules/Assets.module.css";
import Header from "../..//../layouts/Header";
import DownArrow from "../../../assets/icons/arrowdown.svg";
import Clipboard from "../../../assets/icons/clipboard-transparent.svg";
import { WorkOrderList } from "./workOrderList";
import Pagination from "../../Pagination/Pagination";
import { WorkMaintenanceModal } from "../Maintenance/WorkMaintenanceModal";
import "../../../assets/styles/local/workOrder.css";

import { fetchWorkOrders } from "../../../redux/actions/maintenanceAction";
import upArrow from "../../../assets/icons/upArrow.png";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

export const WorkOrders = () => {
  const [query, setQuery] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [addNewBuutonHover, setAddNewButtonHover] = useState(false);
  const [showWorkModal, setShowWorkModal] = useState(false);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workorders-List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const sortByOption = [
    // { label: "Work ID", value: "WorkId" },
    { label: t("Work ID"), value: "WorkId" },

    // { label: "Asset", value: "Asset" },
    { label: t("Asset"), value: "Asset" },

    // { label: "Status", value: "Status" },
    { label: t("Status"), value: "Status" },

    // { label: "Type", value: "Type" },
    { label: t("Type"), value: "Type" },
  ];

  const workOrderList = useSelector((state) => state.maintenance.workOrders);
  const workOrderCount = useSelector(
    (state) => state.maintenance.workOrderCount,
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [shortByArrow, setShortByArrow] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedValue, setSortedValue] = useState("WorkId");
  const [showShortDrop, setShowShortDrop] = useState(false);

  const [workOrders, setWorkOrders] = useState(workOrderList);
  const companyid = window.localStorage.getItem("companyid");

  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleMenuClick = (e) => {};

  useEffect(() => {
    (!workOrderList || !workOrderList.length) && refreshTableListData();
    setWorkOrders(workOrderList);
  }, [workOrderList]);

  useEffect(() => {
    refreshTableListData();
    const newTotalPages = Math.ceil(workOrderCount / perPage);
    setTotalPages(newTotalPages);
  }, [perPage, sortedValue, currentPage, workOrderCount, shortByArrow, query]);

  const refreshTableListData = () => {
    const sortedPayload = shortByArrow
      ? `Ascending-${sortedValue}`
      : `Descending-${sortedValue}`;
    dispatch(
      fetchWorkOrders(
        companyid,
        sortedPayload,
        query,
        perPage,
        currentPage + 1,
      ),
    );
  };

  return (
    <div>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            className="flex-wrap gap-5 d-flex align-items-baseline"
            style={{ display: "flex", gap: "10%" }}
          >
            <div
              className="fw-bold "
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Assets */}
              {t("Assets")}
            </div>
            <div
              className={`fw-bold dropdown col-3`}
              onClick={() => {}}
              style={{
                border: "2px solid #fff", // white border
                backgroundColor: "#fff", // white background color
                color: "#000", // black text color
                padding: "5px 10px", // adjust padding as needed
              }}
            >
              <span
                onClick={() => {
                  //   history.push("/member-list");
                }}
              >
                {/* Work Orders */}
                {t("Work Orders")}
              </span>
            </div>
          </div>
        }
      />
      <div className="work-order-container">
        <div className="workorder-header">
          <section className="d-flex gap-3" style={{ position: "relative" }}>
            <div className="sortBy ps-3">
              {/* Sort by */}
              {t("Sort by")}
            </div>
            <img
              className={
                shortByArrow
                  ? "downSortArrow mt-1 pointer"
                  : "upSortArrow mt-1 pointer"
              }
              src={upArrow}
              alt=""
              onClick={() => {
                setShortByArrow((p) => !p);
              }}
            />
            <div
              className="datetext pointer"
              onClick={() => setShowShortDrop((p) => !p)}
            >
              {sortedValue ? sortedValue : "Select"}
            </div>

            <div
              className="sortDropDiv p-3 w-100"
              style={{
                transform: showShortDrop ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
              }}
            >
              {sortByOption.map((item, index) => {
                return (
                  <div
                    className={
                      sortedValue === item.value
                        ? "datetext pointer"
                        : "pointer"
                    }
                    onClick={() => {
                      setSortedValue(item.value);
                      setShowShortDrop(false);
                    }}
                  >
                    <p className="d-flex gap-">
                      {item.label}
                      {sortedValue === item.value && (
                        <p className="mb-0 ps-3">✓</p>
                      )}
                    </p>
                  </div>
                );
              })}
            </div>
          </section>
          <div>
            {/* Add-new */}
            <Button
              className={styles.addNewButton}
              style={{
                backgroundColor: addNewBuutonHover && "#00246A",
                color: "white",
                // display: addNewBuutonOpen && "none",
              }}
              onClick={() => setShowWorkModal(true)}
              onMouseEnter={() => setAddNewButtonHover(true)}
              onMouseLeave={() => setAddNewButtonHover(false)}
            >
              {addNewBuutonHover && (
                <span
                  style={{
                    color: "#00246A",
                    backgroundColor: addNewBuutonHover && "white",
                    width: "18px",
                    height: "18px",
                    borderRadius: "9px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {"+"}
                </span>
              )}
              {/* <Gridicon /> */}
              {!addNewBuutonHover && (
                <img
                  src={Clipboard}
                  alt=""
                  style={
                    {
                      // backgroundColor: "white",
                      //   borderRadius: "9px",
                      //   width: "18px",
                      //   height: "18px",
                    }
                  }
                />
              )}
              {/* Add New */}
              {t("Add New")}
            </Button>
          </div>
        </div>
        <div className="mt-5 workorder_list_scroll">
          <WorkOrderList
            workOrders={workOrders}
            refreshData={refreshTableListData}
          />
        </div>
        <div>
          <div className="align-text-bottom stock-pagination">
            {showWorkModal ? (
              <WorkMaintenanceModal
                assetMaintainaceId={""}
                showWorkModal={showWorkModal}
                setShowWorkModal={setShowWorkModal}
                refreshData={refreshTableListData}
                from="workOrder"
                type="add"
              />
            ) : (
              ""
            )}
            <Pagination
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
